import { environment } from '@environments/environment';

/**
 * Get Wordpress CMS page id for the slug. Used mainly for the Resources page.
 * @param slugname - pass page slug name to get the page id
 * @returns Page Id for the page slug
 */
export function getPageIdBySlug(slugname: string): number {
  const staticPages = environment.cms.staticpages;
  return slugname && staticPages[slugname];
}
